import { type ReactNode } from 'react';
import { Dimension } from '@hungryroot/ramen';
import styles from './Footer.module.css';

type Props = {
  className?: string;
  childrenBefore?: ReactNode;
  children?: ReactNode;
  backButton?: ReactNode;
  submitButton: ReactNode;
  footerClassName?: string;
  childrenBeforeButtons?: ReactNode;
};

export function Footer({
  childrenBefore,
  className,
  children,
  backButton,
  submitButton,
  childrenBeforeButtons,
}: Props) {
  return (
    <div className={`${styles['footer-wrapper']} ${className}`}>
      {childrenBefore}
      <Dimension as="footer" level="two" className={styles.footer}>
        {childrenBeforeButtons}
        <div className={styles['footer-flex']}>
          {submitButton}
          {children}
          {backButton}
        </div>
      </Dimension>
    </div>
  );
}
